import React from 'react';
import styles from './AdminLayout.module.css';

export default function AdminDashboard() {
  return (
    <div>
      <h2>Admin Dashboard</h2>
      <div className={styles.card}>
        <p>Welcome to your admin dashboard! From here you can manage your blog posts, timeline events, locations, and more.</p>
        
        <div className={styles.infoBox}>
          <h4>Quick Actions</h4>
          <p>Use the navigation above to access different admin sections:</p>
          <ul>
            <li><strong>Data Sync</strong> - Manage automatic data synchronization</li>
            <li><strong>Blog Drafts</strong> - Review and approve AI-generated blog posts</li>
            <li><strong>Affiliate Links</strong> - Manage affiliate marketing links</li>
            <li><strong>NASA API Keys</strong> - Monitor NASA API usage and rate limits</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
